<app-page-breadcrumb pageTitle="Reuniones"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <!-- Left side -->
    <div class="flex items-center gap-1.5">
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
       <button
        type="button"
        (click)="irAKanban()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path>
        </svg>
        Kanban
      </button>
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        *appHasPermission="'meetings:create'"
        (click)="crearReunionInstantanea()"
        [disabled]="creandoInstantanea"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-brand-500 text-brand-600 dark:text-brand-400 hover:bg-brand-50 dark:hover:bg-brand-500/10 disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-1.5">
        @if (creandoInstantanea) {
          <span class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></span>
        } @else {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
          </svg>
        }
        {{ creandoInstantanea ? 'Creando...' : 'Reunión instantánea' }}
      </button>
      <button
        type="button"
        *appHasPermission="'meetings:create'"
        (click)="nuevaReunion()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nueva Reunión
      </button>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Búsqueda por título/descripción -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar reunión
        </label>
        <input
          type="text"
          [(ngModel)]="filtroSearchTerm"
          (ngModelChange)="buscar()"
          placeholder="Título o descripción..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Filtro Tipo de reunión -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Tipo de reunión
        </label>
        <select
          [(ngModel)]="filtroIdMeetingType"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los tipos</option>
          @for (type of meetingTypes; track type.id) {
          <option [ngValue]="type.id">{{ type.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Estado -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado
        </label>
        <select
          [(ngModel)]="filtroIdMeetingStatus"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los estados</option>
          @for (status of meetingStatuses; track status.id) {
          <option [ngValue]="status.id">{{ status.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Contacto (por nombre) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Contacto
        </label>
        <select
          [(ngModel)]="filtroContactId"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los contactos</option>
          @for (c of contacts; track c.id) {
            <option [ngValue]="c.id">{{ c.name }}{{ c.email ? ' (' + c.email + ')' : '' }}</option>
          }
        </select>
      </div>

      <!-- Fecha desde -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Fecha desde
        </label>
        <input
          type="date"
          [(ngModel)]="filtroDateFrom"
          (ngModelChange)="buscar()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent dark:[color-scheme:dark] cursor-pointer">
      </div>

      <!-- Fecha hasta -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Fecha hasta
        </label>
        <input
          type="date"
          [(ngModel)]="filtroDateTo"
          (ngModelChange)="buscar()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent dark:[color-scheme:dark] cursor-pointer">
      </div>

      <!-- Filtro Negocio/Deal (por nombre) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Negocio
        </label>
        <select
          [(ngModel)]="filtroDealId"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los negocios</option>
          @for (d of deals; track d.id) {
            <option [ngValue]="d.id">{{ d.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Organizador (por nombre) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Organizador
        </label>
        <select
          [(ngModel)]="filtroOrganizerId"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos los organizadores</option>
          @for (u of organizers; track u.id) {
            <option [ngValue]="u.id">{{ u.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Empresa (por nombre) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Empresa</label>
        <select
          [(ngModel)]="filtroCompanyId"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas las empresas</option>
          @for (co of companies; track co.id) {
            <option [ngValue]="co.id">{{ co.name }}</option>
          }
        </select>
      </div>

      <!-- Rango temporal -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Rango temporal</label>
        <select [(ngModel)]="filtroTimeRange" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="all">Todas</option>
          <option value="upcoming">Próximas</option>
          <option value="past">Pasadas</option>
        </select>
      </div>

      <!-- No-show -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Asistencia</label>
        <select [(ngModel)]="filtroIsNoShow" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="">Todas</option>
          <option value="false">Asistió</option>
          <option value="true">No-show</option>
        </select>
      </div>

      <!-- Estado de pago -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Pago</label>
        <select [(ngModel)]="filtroPaymentStatus" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="">Todos</option>
          <option value="pending">Pendiente</option>
          <option value="paid">Pagado</option>
          <option value="refunded">Reembolsado</option>
          <option value="failed">Fallido</option>
        </select>
      </div>

      <!-- Source -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Origen</label>
        <select [(ngModel)]="filtroSource" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="">Todos</option>
          <option value="manual">Manual</option>
          <option value="booking_page">Booking page</option>
          <option value="api">API</option>
          <option value="import">Import</option>
        </select>
      </div>

      <!-- Boton Limpiar Filtros -->
      <div class="flex items-end">
        <button
          type="button"
          (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando reuniones...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Tabla de reuniones -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <!-- Table Header -->
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Título</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Fecha y Hora</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Contacto</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Ubicación</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (meetings.length === 0) {
          <tr>
            <td colspan="7" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                  </path>
                </svg>
                <span>No hay reuniones registradas</span>
              </div>
            </td>
          </tr>
          }

          @for (meeting of meetings; track meeting.id) {
          <tr>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block font-medium text-gray-800 dark:text-white/90">
                {{ meeting.title }}
              </span>
              @if (meeting.description) {
              <span class="block text-xs text-gray-500 dark:text-gray-400 truncate max-w-xs">
                {{ meeting.description }}
              </span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block text-xs text-gray-600 dark:text-gray-300">
                {{ formatFecha(meeting.datetimeStart) }}
              </span>
              <span class="block text-xs text-gray-500">
                {{ formatHora(meeting.datetimeStart) }} - {{ formatHora(meeting.datetimeEnd) }}
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-badge [color]="'info'">
                {{ getMeetingTypeName(meeting) }}
              </app-badge>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <div class="flex flex-wrap items-center gap-1">
                <app-badge [color]="getStatusColor(meeting)"
                  [title]="estaCancelada(meeting) ? estadoOriginal(meeting) : ''">
                  {{ getMeetingStatusName(meeting) }}
                </app-badge>
                @if (meeting.isNoShow) {
                  <app-badge [color]="'error'">No-show</app-badge>
                }
                @if (meeting.paymentStatus) {
                  <app-badge [color]="getPaymentBadgeColor(meeting.paymentStatus)">
                    {{ getPaymentStatusLabel(meeting.paymentStatus) }}
                  </app-badge>
                }
                @if (meeting.source && meeting.source !== 'manual') {
                  <app-badge [color]="'light'">{{ getSourceLabel(meeting.source) }}</app-badge>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (meeting.contactId) {
              <span class="text-xs">
                {{ getContactName(meeting.contactId) }}
              </span>
              }
              @else {
              <span class="text-xs text-gray-400">Sin contacto</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              @if (canJoinJitsi(meeting)) {
              <button (click)="unirseJitsi(meeting)"
                class="inline-flex items-center gap-1 rounded-md bg-brand-500 px-2.5 py-1 text-xs font-medium text-white hover:bg-brand-600 transition-colors">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                </svg>
                Unirse
              </button>
              } @else if (meeting.location) {
              <span class="text-xs truncate max-w-[150px] block" [title]="meeting.location">
                {{ meeting.location }}
              </span>
              } @else if (meeting.meetingUrl) {
              <a [href]="meeting.meetingUrl" target="_blank" class="text-brand-500 hover:underline text-xs flex items-center gap-1">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                </svg>
                Virtual
              </a>
              } @else {
              <span class="text-xs text-gray-400">Sin ubicación</span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-2">
                <button (click)="verDetalle(meeting)"
                  class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                  title="Ver detalle">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                    </path>
                  </svg>
                </button>
                <button (click)="editarReunion(meeting)"
                  *appHasPermission="'meetings:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>
                <button (click)="reprogramarReunion(meeting)"
                  *appHasPermission="'meetings:edit'"
                  class="rounded-lg p-2 hover:bg-warning-50 hover:text-warning-600 dark:hover:bg-warning-500/10 dark:hover:text-warning-400 transition-colors"
                  title="Reprogramar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </button>
                <button (click)="cancelarReunion(meeting)"
                  *appHasPermission="'meetings:edit'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 dark:hover:bg-error-500/10 dark:hover:text-error-400 transition-colors"
                  title="Cancelar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </button>
                <button (click)="eliminarReunion(meeting)"
                  *appHasPermission="'meetings:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginacion -->
    @if (totalPages > 1) {
    <div class="border-t border-gray-100 px-5 py-4 dark:border-white/[0.05]">
      <div class="flex items-center justify-between">
        <div class="text-sm text-gray-500 dark:text-gray-400">
          Página {{ paginasDisplay }} de {{ totalPages }} ({{ totalItems }} reuniones)
        </div>
        <div class="flex gap-2">
          <app-button variant="outline" size="sm" (btnClick)="cambiarPagina(paginasDisplay - 1)"
            [disabled]="!hasPreviousPage">
            Anterior
          </app-button>
          <app-button variant="outline" size="sm" (btnClick)="cambiarPagina(paginasDisplay + 1)"
            [disabled]="!hasNextPage">
            Siguiente
          </app-button>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>


<app-meeting-detail-modal
  [isOpen]="showDetailModal"
  [meeting]="selectedMeeting"
  (close)="cerrarModal()">
</app-meeting-detail-modal>

<!-- Modal Cancelar reunión (INC 48) -->
<app-meeting-cancel-dialog
  [isOpen]="showCancelDialog"
  [meeting]="accionMeeting"
  (cancelled)="cerrarCancelDialog()"
  (confirmed)="onAccionConfirmada()">
</app-meeting-cancel-dialog>

<!-- Modal Reprogramar reunión (INC 48) -->
<app-meeting-reschedule-dialog
  [isOpen]="showRescheduleDialog"
  [meeting]="accionMeeting"
  (cancelled)="cerrarRescheduleDialog()"
  (confirmed)="onAccionConfirmada()">
</app-meeting-reschedule-dialog>

<!-- Videollamada Jitsi inline (organizador entra sin salir del CRM) -->
@if (jitsiMeeting) {
  <app-jitsi-room
    [roomName]="jitsiRoomName()"
    [displayName]="jitsiDisplayName()"
    [email]="jitsiEmail()"
    [title]="jitsiMeeting.title"
    [datetimeStart]="jitsiMeeting.datetimeStart"
    (close)="cerrarJitsi()">
  </app-jitsi-room>
}
